export default "__VITE_ASSET__BhHswl95__"